export abstract class Filter {
	public order_by: string;
	public asc: boolean;
	public page_size: number;
	public page: number;
	public exclude_status: string;
	public working_status: string | string[];
	public cod_axus: string;
	public storage_change_requested: boolean;

	abstract clone(): Filter;
	abstract getFilterUrl(): string;
	abstract newFilter(model?: any): Filter;
}

export enum EFilterForm {
	order_by	= 'order_by',
	asc				= 'asc',
	page_size =	'page_size',
	page			= 'page',
}